import type { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical'

const nodeToText = (nodes: any[]): string => {
  if (!Array.isArray(nodes)) return ''

  return nodes
    .map((node) => {
      if (!node || typeof node !== 'object') return ''

      if (typeof node.text === 'string') {
        return node.text
      }

      if (node.type === 'linebreak') {
        return '\n'
      }

      if (Array.isArray(node.children)) {
        return nodeToText(node.children)
      }

      return ''
    })
    .join(' ')
}

export const richTextToPlainText = (
  data?: SerializedEditorState | null,
  limit?: number,
): string => {
  if (!data?.root) return ''

  const rawText = nodeToText(data.root.children).replace(/\s+/g, ' ').trim()

  if (limit && rawText.length > limit) {
    return `${rawText.slice(0, limit).trim()}…`
  }

  return rawText
}

